var _style, _g, _path, _path2, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    xmlSpace: "preserve",
    y: 0,
    x: 0,
    id: "Layer_1",
    viewBox: "-119.95785 -40.211 1039.6347 241.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style6578",
    type: "text/css"
  }, ".st0{fill:#2b8ca1}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.161 .019)",
    id: "g3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.2 69.5h44.7c3.1 0 3.7 3.2 1.3 7.1l-9 14.8c-2.4 3.9-6.9 7.1-10 7.1h-44.7c-3.1 0-3.7-3.2-1.3-7.1l9-14.8c2.4-3.9 6.9-7.1 10-7.1",
    className: "st0",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.9.1c16.4-1.5 35.9 11.4 26.3 28.3-9.2 15.3-42.5 19.2-52.5 18.3-3.2-.3-8.4-2.3-8.3-7.4.1-3.6 2.1-16.2 9-26.1C401.6 3.5 412.2.6 419.9.1",
    className: "st0",
    id: "path7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M522.139 32.819c5.1-2.3 5.6 3.3 5.4 5v13c0 2.5 2.1 1.3 3.2.9 15.4-6.5 31-16.2 50.8-15.7 17.6.4 22.9 14.3 22.8 30.3v68.1c0 6 .5 7.4 3.3 9.7.9.5 5.6.9 7.4.9 1.9 0 1.9 1.4 1.4 2.8l-4.2 10.7c-.9 1.8-2.8 2.3-4.2 2.3h-40c-13.9-.5-18.1-10.9-17.9-16.2v-64.8c0-13.3-21.7-14.3-21.7 3.6v54.6c.2 2.6-.6 6 6.4 6.5 4.6 0 7.9-.5 5.6 5.1l-3.4 8.6c-.8 1.6-2.7 2.6-4.5 2.5h-66.1c-1.4 0-2.5-1.6-2.3-2.8l4.7-12.1c.2-.5.7-1.4 1.3-1.4 2.2-.1 3.7-1.2 4.1-7.4v-71c0-5.8-5.3-5.1-9.3-5.1-1.8 0-2.8-.5-2.3-2.8l3.7-7.9c.5-1.9 1.4-2.6 2.8-2.8 21.8-3.3 34.4-4.8 53-14.6",
    className: "st0",
    id: "path9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M683.539 2.919c3.8-.6 6 1.7 6 5.9v68c.5 3.7 3.2 1.2 4 .1l23.5-29.8c2.5-3.1 8.5-3.7 12.2-3.7h51.2c.9 0 1.4 1.1.5 2.3l-6.5 8.8c-.6.8-1.1 1.8-4.2 1.8h-2.5c-2.3.1-2.8.9-3.7 1.4l-26.3 29.5c-5.5 6.6-4.2 9.4.7 14.1l36.1 37c8 5.6 15.3 6 23.6 6.5 2.2.1 1.7 1.9.9 2.8l-9.3 10.7c-.9 1.4-5 2.3-7.3 2.3h-35.8c-4.6 0-12.9-1.4-19.4-5.6-13-10.7-21.2-24.2-33.9-36.2-2.2-2.1-4-1.1-4 .7v15.5c0 7 2.9 8.8 13.1 9.3 3.9.2 2.8 2.3 1.9 4.6l-3.4 8.8c-1 2.1-2.3 2.8-4.1 2.8h-74c-2.3 0-3.8-.7-3.3-2.1l4.1-10.9c.9-2.1 1.5-2.6 4.6-2.8 5.1-.3 7-2 7.1-9.6v-100c0-3.4-.8-4.7-3.2-4.4l-9.4 1.3c-2.8.4-3.3-1.7-2.2-3.7l5.8-9.7c1.1-1.9 3.1-2.1 5.3-2.5 18.9-3.1 38-8.6 49.7-13 .7.2 1.3-.1 2.2-.2",
    className: "st0",
    id: "path11"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.161 .019)",
    id: "g13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.9 43c2.3-.9 5.1.9 4.6 6v88.1c1.2 6.2 3.2 7.7 8.7 8.3 0 0 3.8.1 2.8 2.8l-3.6 9.3c-1.4 2.8-2.3 3.3-5.6 3.3h-68.9c-1.8-.1-2.5-1.3-1.9-3.3l3.4-8.8c.6-1.2.9-2.4 3.2-2.8 7-1.9 7.4-2.8 7.4-12.1V81.1c0-8.8-1.4-8.4-11.6-7.4-1.8-.5-1.7-2.2-1.4-2.8l5.1-9.7c1.4-2.8 3.2-2.8 3.2-2.8 19.6-1.5 39.1-6.4 54.6-15.4",
    className: "st0",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1 160.7c15 .2 33.1 1 49.9-12.1 12-7.9 26.4-39.9 31.6-53.1 2.6-6.9 3.3-16 0-22.9-9.1-20.6-22.3-43.6-31-52.9-12.5-11.5-24.2-12.5-43.7-12.5H20.7c-3.5 0-7.4.9-8.8 3.3l-6 11.1c-.9 4.6 4.6 5.1 4.6 5.1H19c2.3 0 2.8 1.8 2.8 3.7v103c0 4.6-5.2 7.4-9.4 8.3-1.9.5-4.6 1-6 3.3l-6 11.6c-.9 2.3.9 4.2 2.8 4.2 32.7 0 61.1.1 93.9-.1M76 141.6V30.9c0-2.8.5-4.2 3.2-4.6h8.1c2.9 0 7.1-.6 9.7 4L124.9 79c2.3 5.1 1.6 7.2 0 10.7l-28.3 47.8c-3.4 4.7-5 3.8-9.3 4.1-.1 0 .1 0 0 0z",
    className: "st0",
    id: "path17"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M334.439 8.319c3.6 0 4.9 2.1 4.2 3.5l-7.4 13.5s-.9 2.8-7.4 2.8h-.7c-4.2 0-7.5 0-7.9 8.4v97.8c0 4.2 1.8 7.7 6.9 7.9h10.1c16.5-.2 16.1-17.2 19.8-32 .9-2.3 1.4-3.7 4.2-5.1l14.6-5.1c1.9 0 3.7 0 4.2 3.2v49.2c.5 4.6-3.7 8.8-9.3 8.3h-125.6c-4.6 0-5.6-1.4-4.6-4.2l4.6-10.2s1.4-2.8 5.6-2.8c9.3-.5 15.1-.6 15-14.8v-91.4c0-6-1.4-9.7-7.5-9.7h-7.1c-4.6 0-7.1-1.6-6-4.2l6.5-12.1c1.5-2.7 2.8-3.1 5.1-3.1h82.7",
    className: "st0",
    id: "path19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand3);
export default __webpack_public_path__ + "static/media/brand3.49589bffdbeb43b164d653566e4cce6c.svg";
export { ForwardRef as ReactComponent };